import { ObjectWrapper } from '../wrappers/object.wrapper';
import { Util } from './util';
import { WrapperUtil } from './wrapper.util';
import { ClipboardCache } from '../caches/clipboard.cache';
import { DatabaseWrapper } from '../databases/database.wrapper';
import { ErrorCdsEnums } from '../errorcds.enums';
import { TransformsUtil } from 'src/app/modules/design/transforms/transforms.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { DatabaseWrappersFactory } from '../databases/database.wrappers.factory';
import { AttributeCarryForward } from '../beans/attributecarryforward';
import { ParamObj } from '../models/objs/paramobj';
import { CommonEnums } from '../common.enums';
import { DatabaseEnum } from '../databases/databases.enum';
import { MapUtil } from '../models/utils/map.util';
import { Attribute } from '../models/domain/attribute';
import { ArrayUtil } from '../models/utils/array.util';
import { LabelValueObj } from '../beans/labelvalueobj';

export class ObjectWrapperUtil {
    setShortNameForDashboardsOutList(dashboardsCndNm: string): any {
        throw new Error('Method not implemented.');
    }
    private static instance: ObjectWrapperUtil;

    static getInstance() {
        if (!ObjectWrapperUtil.instance) {
            ObjectWrapperUtil.instance = new ObjectWrapperUtil();
        }

        return ObjectWrapperUtil.instance;
    }

    util: Util;
    wrapperUtil: WrapperUtil;
    clipboardCache: ClipboardCache;
    databaseWrappersFactory: DatabaseWrappersFactory

    /**
    * ObjectWrapperUtil is a singleton class, so use ObjectWrapperUtil.getInstance() method instead of creating new ObjectWrapperUtil().
    */
    private constructor() {
        this.util = Util.getInstance();
        this.wrapperUtil = WrapperUtil.getInstance();
        this.clipboardCache = ClipboardCache.getInstance();
        this.databaseWrappersFactory = DatabaseWrappersFactory.getInstance();
    }


    packSubObjects(idField: string, nameField: string, subObjects: Array<any>, objectWrapper: ObjectWrapper): void {
        objectWrapper.sub_Ids.clear();
        objectWrapper.subNames.splice(0, objectWrapper.subNames.length);

        for (let i: number = 0; i < subObjects.length; i++) {
            let subObject: any = subObjects[i];
            objectWrapper.sub_Ids.set(subObject[idField], subObject);

            let parent_Attr_Id: string = subObject.parent_Attr_Id != undefined && subObject.parent_Attr_Id != -1 ? subObject.parent_Attr_Id.toString() : '';
            objectWrapper.subNames.push(parent_Attr_Id + subObject[nameField].toUpperCase());
        }
    }

    removeSub_Id(sub_Id: number, objectWrapper: ObjectWrapper): void {
        if (objectWrapper.sub_Ids.get(sub_Id) == undefined) return;

        objectWrapper.sub_Ids.delete(sub_Id);
    }

    getNewSub_Id(objectWrapper: ObjectWrapper): number {
        let maxNumber: number = MapUtil.getInstance().getMaxNumber(objectWrapper.getSub_Ids());
        return maxNumber + 1;
    }

    removeSubName(subName: string, objectWrapper: ObjectWrapper): void {
        subName = subName.toUpperCase();

        // if (objectWrapper.hasOwnProperty("databaseNms")) {
        //     let index = objectWrapper.databaseNms.indexOf(subName)
        //     if (index == -1) return;
        //     objectWrapper.databaseNms.splice(index, 1)
        // } else {
        let index = objectWrapper.subNames.indexOf(subName);
        if (index == -1) return;

        objectWrapper.subNames.splice(index, 1);
        // }
    }

    insertAt(subObject: any, sub_IdField: string, subNameField: string, index: number, subObjects: Array<any>,
        objectWrapper: ObjectWrapper, clevel: number = -1): any {
        if (index == 0)
            subObjects.push(subObject);
        else
            subObjects.splice(index, 0, subObject);

        this.resetSrt_Order(subObjects, index);
        objectWrapper.doValidate();

        subObject = this.getSubObject(subObject[sub_IdField], sub_IdField, subObjects);
        if (subObject.clevel != undefined &&
            subObject.clevel != -1) {
            subObject.clevel = clevel;
        }

        let parent_Attr_IdString: string = '';
        if (subObject.hasOwnProperty('parent_Attr_Id')) {
            parent_Attr_IdString = subObject.parent_Attr_Id.toString();
        }

        objectWrapper.sub_Ids.set(subObject[sub_IdField], subObject);
        this.addSubName(subObject[subNameField], objectWrapper, parent_Attr_IdString);

        return subObject;
    }

    insertsAt(insertSubObjects: Array<any>, sub_IdField: string, subNameField: string, index: number,
        subObjects: Array<any>, objectWrapper: ObjectWrapper): Array<any> {
        let insertedSubObjects: Array<any> = new Array<any>();

        for (let i: number = 0; i < insertSubObjects.length; i++) {
            let insertSubObject: any = insertSubObjects[i];

            insertSubObject[sub_IdField] = this.getNewSub_Id(objectWrapper);
            insertSubObject[subNameField] = this.util.getNewName(insertSubObject[subNameField], objectWrapper.subNames);
            insertSubObject.srt_Order = index + i;

            subObjects.splice(insertSubObject.srt_Order, 0, insertSubObject);

            let parent_Attr_Id = insertSubObject.hasOwnProperty('parent_Attr_Id') ? insertSubObject.parent_Attr_Id : undefined;

            this.addSub_Id(insertSubObject[sub_IdField], insertSubObject, objectWrapper);
            this.addSubName(insertSubObject[subNameField], objectWrapper, parent_Attr_Id);

            insertedSubObjects.push(this.getSubObject(insertSubObject[sub_IdField], sub_IdField, subObjects));
        }

        this.resetSrt_Order(subObjects, index);
        //objectWrapper.doValidate();

        return insertedSubObjects;
    }

    resetSrt_Order(list: Array<any>, index: number = 0): void {
        let listLength: number = list.length;
        for (let i: number = index; i < listLength; i++) {
            list[i].srt_Order = i;
        }
    }

    getSubObject(sub_Id: number, sub_IdField: string, subObjects: Array<any>): any {
        for (let i: number = 0; i < subObjects.length; i++) {
            let subObject: any = subObjects[i];
            if (subObject[sub_IdField] == sub_Id) {
                return subObject;
            }
        }

        return null;
    }

    addSub_Id(sub_Id: number, subObject: any, objectWrapper: ObjectWrapper) {
        objectWrapper.sub_Ids.set(sub_Id, subObject);
    }

    addSubName(subName: string, objectWrapper: ObjectWrapper, parent_Attr_IdString: string = ''): void {
        parent_Attr_IdString = parent_Attr_IdString != undefined && parent_Attr_IdString != '-1' ? parent_Attr_IdString : '';
        subName = parent_Attr_IdString + subName.toUpperCase();
        if (objectWrapper.subNames.indexOf(subName) != -1) return;
        objectWrapper.subNames.push(subName);
    }

    updateSubName(newSubName: string, oldSubName: string, objectWrapper: ObjectWrapper): void {
        let index: number = objectWrapper.subNames.indexOf(oldSubName.toUpperCase());
        if (index != -1) {
            objectWrapper.subNames.splice(index, 1);
        }

        objectWrapper.subNames.push(newSubName.toUpperCase());
    }

    cut(selectedSubObjects: Array<any>, sub_IdField: string, subNameField: string, sortField: string,
        subObjects: Array<any>, objectWrapper: ObjectWrapper): Array<any> {
        this.clipboardCache.setCopiedItems(selectedSubObjects, false, sortField);
        return this.remove(selectedSubObjects, sub_IdField, subNameField, subObjects, objectWrapper);
    }

    copy(selectedSubObjects: Array<any>, sortField: string): void {
        this.clipboardCache.setCopiedItems(selectedSubObjects, true, sortField);
    }

    remove(selectedSubObjects: Array<any>, sub_IdField: string, subNameField: string,
        subObjects: Array<any>, objectWrapper: ObjectWrapper): Array<any> {
        let deletedSubObjects: Array<any> = new Array<any>();
        let index: number;

        let sub_IdsMap: Map<number, any> = new Map<number, any>();
        for (let i: number = 0; i < selectedSubObjects.length; i++) {
            let selectedSubObject: any = selectedSubObjects[i];
            if (selectedSubObject.hasOwnProperty('isEditable') &&
                selectedSubObject.isEditable == 'N' && objectWrapper.dbTyp_Id != 9) continue;

            sub_IdsMap.set(selectedSubObject[sub_IdField], selectedSubObject);
        }

        for (let i: number = subObjects.length - 1; i >= 0; i--) {
            let selectedSubObject: any = sub_IdsMap.get(subObjects[i][sub_IdField]);
            if (selectedSubObject) {
                index = i;
                let splicedSubObjects = subObjects.splice(index, 1);
                deletedSubObjects.push(splicedSubObjects[0]);

                this.removeSubName(selectedSubObject[subNameField], objectWrapper);
                this.removeSub_Id(selectedSubObject[sub_IdField], objectWrapper);
            }
        }

        // for (let i = selectedSubObjects.length - 1; i >= 0; i--) {
        //     let selectedSubObject = selectedSubObjects[i];

        //     if (selectedSubObject.hasOwnProperty('isEditable') &&
        //         selectedSubObject.isEditable == 'N' && objectWrapper.dbTyp_Id != 9) continue;

        //     index = subObjects.indexOf(selectedSubObject);
        //     if (index != -1) {
        //         let splicedSubObjects = subObjects.splice(index, 1);
        //         deletedSubObjects.push(splicedSubObjects[0]);

        //         this.removeSubName(selectedSubObject[subNameField], objectWrapper);
        //         this.removeSub_Id(selectedSubObject[sub_IdField], objectWrapper);
        //     }
        // }

        this.resetSrt_Order(subObjects, index);
        //objectWrapper.doValidate();

        return deletedSubObjects;
    }

    downItems(selectedItems: Array<any>, items: Array<any>, idField: string, srt_OrderField: string): Array<number> {
        selectedItems = ArrayUtil.getInstance().sort(selectedItems, srt_OrderField);

        let selectedItem_Ids: Array<number> = new Array<number>();
        let selectedItemsTmp: Array<any> = new Array<any>();
        let index: number = 0;
        for (let i: number = selectedItems.length - 1; i >= 0; i--) {
            let selectedItem: any = selectedItems[i];
            selectedItem_Ids.push(selectedItem.attr_Id);

            index++;
            if (selectedItem[srt_OrderField] == items.length - index) continue;

            selectedItemsTmp.push(selectedItem);
        }
        if (selectedItemsTmp.length == 0) return;

        for (let i: number = 0; i < selectedItemsTmp.length; i++) {
            let selectedItem: any = selectedItemsTmp[i];
            let srt_Order: number = selectedItem[srt_OrderField];

            let deletedItems: Array<any> = items.splice(srt_Order, 1);
            items.splice(srt_Order + 1, 0, deletedItems[0]);

            deletedItems[0].srt_Order++;
            items[srt_Order].srt_Order--;
        }

        return selectedItem_Ids;
    }

    upItems(selectedItems: Array<any>, items: Array<any>, idField: string, srt_OrderField: string): Array<number> {
        selectedItems = ArrayUtil.getInstance().sort(selectedItems, srt_OrderField);

        let selectedItem_Ids: Array<number> = new Array<number>();
        let selectedItemsTmp: Array<any> = new Array<any>();
        for (let i: number = 0; i < selectedItems.length; i++) {
            let selectedItem: any = selectedItems[i];
            selectedItem_Ids.push(selectedItem.attr_Id);
            if (selectedItem[srt_OrderField] == i) continue;

            selectedItemsTmp.push(selectedItem);
        }
        if (selectedItemsTmp.length == 0) return;

        for (let i: number = 0; i < selectedItemsTmp.length; i++) {
            let selectedItem: any = selectedItemsTmp[i];
            let srt_Order: number = selectedItem[srt_OrderField];

            let deletedItems: Array<any> = items.splice(srt_Order, 1);
            items.splice(srt_Order - 1, 0, deletedItems[0]);

            deletedItems[0].srt_Order--;
            items[srt_Order].srt_Order++;
        }

        this.resetSrt_Order(items);

        return selectedItem_Ids;
    }
    verifyisFileType(dbTypeId) {

        if (dbTypeId == DatabaseEnum.flatfile.ID || dbTypeId == DatabaseEnum.cobol.ID || dbTypeId == DatabaseEnum.salesforce.ID || dbTypeId == DatabaseEnum.dfs.ID ||
            dbTypeId == DatabaseEnum.json.ID || dbTypeId == DatabaseEnum.hbase.ID || dbTypeId == DatabaseEnum.xsd.ID ||
            dbTypeId == DatabaseEnum.twitter.ID || dbTypeId == DatabaseEnum.facebook.ID || dbTypeId == DatabaseEnum.jms.ID ||
            dbTypeId == DatabaseEnum.kafka.ID || dbTypeId == DatabaseEnum.sas.ID || dbTypeId == DatabaseEnum.avro.ID ||
            dbTypeId == DatabaseEnum.parquet.ID || dbTypeId == DatabaseEnum.druid.ID || dbTypeId == DatabaseEnum.google_doubleclick_search.ID ||
            dbTypeId == DatabaseEnum.google_analytics.ID || dbTypeId == DatabaseEnum.google_adwords.ID || dbTypeId == DatabaseEnum.activedirectory.ID ||
            dbTypeId == DatabaseEnum.iothub.ID || dbTypeId == DatabaseEnum.office365.ID || dbTypeId == DatabaseEnum.jsonc.ID) {
            return true;
        } else {
            return false;
        }
    }

    up(selectedSubObjects: Array<any>, subObjects: Array<any>): void {
        for (let i: number = 0; i < selectedSubObjects.length; i++) {
            if (selectedSubObjects[i].srt_Order == 0) {
                return;
            }
        }

        let index: number = -1;
        let splicedSubObjects: Array<any> = new Array<any>();
        for (let i: number = 0; i < selectedSubObjects.length; i++) {
            if (selectedSubObjects[i].srt_Order == 0) {
                return;
            }
            index = selectedSubObjects[i].srt_Order;
            splicedSubObjects = subObjects.splice(index, 1);
            subObjects.splice.apply(subObjects, [index - 1, 0].concat(splicedSubObjects));
        }

        this.resetSrt_Order(subObjects);
    }

    upComplex(selectedSubObjects: Array<any>, subObjects: Array<any>, jumpCount: number, objectWrapper: ObjectWrapper): void {
        let index: number;
        let isOneBatch: boolean = true;
        let srt_Order: number = selectedSubObjects[0].srt_Order;
        let splicedSubObjects: Array<any>;
        for (let i: number = 1; i < selectedSubObjects.length; i++) {
            if (selectedSubObjects[i].srt_Order != (srt_Order + i)) {
                isOneBatch = false;
                break;
            }
        }

        if (isOneBatch) {
            index = subObjects.indexOf(selectedSubObjects[0]);
            splicedSubObjects = subObjects.splice(index, selectedSubObjects.length);
            subObjects.splice.apply(subObjects, [index - jumpCount, 0].concat(splicedSubObjects));
        } else {
            for (let i: number = 0; i < selectedSubObjects.length; i++) {
                for (let j: number = 0; j < jumpCount; j++) {
                    index = subObjects.indexOf(selectedSubObjects[i]);
                    if (index <= 0) continue;

                    splicedSubObjects = subObjects.splice(index, 1);
                    subObjects.splice(index - 1, 0, splicedSubObjects[0]);
                }
            }
        }

        this.resetSrt_Order(subObjects, index);
        objectWrapper.doValidate();
    }

    down(selectedSubObjects: Array<any>, subObjects: Array<any>): void {
        let index: number = -1;
        let splicedSubObjects: Array<any> = new Array<any>();
        for (let i: number = selectedSubObjects.length - 1; i >= 0; i--) {
            if (selectedSubObjects[i].srt_Order == subObjects.length - 1) {
                return;
            }
            index = selectedSubObjects[i].srt_Order;
            splicedSubObjects = subObjects.splice(index, 1);
            subObjects.splice.apply(subObjects, [index + 1, 0].concat(splicedSubObjects));
        }

        this.resetSrt_Order(subObjects);
    }

    downComplex(selectedSubObjects: Array<any>, subObjects: Array<any>, jumpCount: number, objectWrapper: ObjectWrapper) {
        for (let i: number = 0; i < selectedSubObjects.length; i++) {
            if (selectedSubObjects[i].srt_Order == subObjects.length - 1) {
                return;
            }
        }

        let index: number;
        let isOneBatch: boolean = true;
        let srt_Order: number = selectedSubObjects[0].srt_Order;
        let splicedSubObjects: Array<any>;
        for (let i: number = 1; i < selectedSubObjects.length; i++) {
            if (selectedSubObjects[i].srt_Order != (srt_Order + i)) {
                isOneBatch = false;
                break;
            }
        }

        if (isOneBatch) {
            index = subObjects.indexOf(selectedSubObjects[0]);
            splicedSubObjects = subObjects.splice(index, selectedSubObjects.length);
            subObjects.splice.apply(subObjects, [index + jumpCount, 0].concat(splicedSubObjects));
        } else {
            for (let i: number = selectedSubObjects.length - 1; i >= 0; i--) {
                for (let j: number = 0; j < jumpCount; j++) {
                    index = subObjects.indexOf(selectedSubObjects[i]);

                    splicedSubObjects = subObjects.splice(index, 1);
                    subObjects.splice(index + 1, 0, splicedSubObjects[0]);
                }
            }
        }

        this.resetSrt_Order(subObjects, index);
        objectWrapper.doValidate();
    }

    clearCarryForwardAttributes(objectWrapper: ObjectWrapper): void {
        this.util.splice(objectWrapper.carryForwardAttributesNamesList);
        objectWrapper.carryForwardAttributesHMapIds.clear();
        //this.util.splice(objectWrapper.carryForwardAttributesHMapIds);
        objectWrapper.carryForwardAttributeObjectsHMapIds.clear();
        this.util.splice(objectWrapper.carryForwardAttributes);
        this.util.splice(objectWrapper.carryForwardGroupAttributes);
    }

    getPerformanceLAttributeObject(lAttribute: any, objectWrapper: ObjectWrapper): any {
        let lAttributeObject: any = {};

        lAttributeObject.obj_Id = objectWrapper.obj_Id;
        lAttributeObject.obj_Nm = objectWrapper.name;
        lAttributeObject.attr_Id = lAttribute.attr_Id;
        lAttributeObject.dTyp_Attr_Id = lAttribute.attrDTyp_Id;
        lAttributeObject.attrDTyp_Id = lAttribute.attrDTyp_Id;
        lAttributeObject.text = lAttribute.attrNm;
        lAttributeObject.name = objectWrapper.name + '.' + lAttributeObject.text;
        lAttributeObject.type = 'L';

        lAttributeObject.lnk_Obj_Inst_Id = lAttribute.lnk_Obj_Id;
        lAttributeObject.lnk_Attr_Id = lAttribute.lnk_Attr_Id;
        lAttributeObject.showUnderline = true;
        let nativeDbTyp_Id = objectWrapper.nativeDbTyp_Id == -2 ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id;

        lAttributeObject.attrDTyp_Name = this.databaseWrappersFactory.getDatatypeName(nativeDbTyp_Id, lAttribute.attrDTyp_Id);

        return lAttributeObject;
    }


    getAttributeObject(attribute: Attribute, objectWrapper: ObjectWrapper, obj_Nm: string = '', nativeDbTyp_Id: number = -1) {
        let attributeObject: any = {};

        attributeObject.objectName = "Attribute";

        attributeObject.obj_Id = objectWrapper.obj_Id;
        attributeObject.obj_Nm = obj_Nm != '' ? obj_Nm : objectWrapper.name;
        attributeObject.attr_Id = attribute.attr_Id;
        attributeObject.text = attribute.attrNm;
        attributeObject.clevel = attribute.clevel;
        attributeObject.explodeFlag = attribute.explodeFlag;
        attributeObject.parent_Attr_Id = attribute.parent_Attr_Id;

        attributeObject.parentAttribute = null;
        attributeObject.showUnderline = attribute.showUnderline;
        attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;
        //TBD attributeObject.name = attribute.attrFullNm ? attribute.attrFullNm : attributeObject.obj_Nm + '.' + attribute.attrNm;


        /*if(  objectWrapper.hasOwnProperty('dataObjectWrapper') &&
                objectWrapper.dataObjectWrapper.dataObject.dObj.caseSensitiveFlg == "Y" &&
                ( objectWrapper.dbTyp_Id == 2 ||
                  objectWrapper.dbTyp_Id == 0 ||
                  objectWrapper.dbTyp_Id == 7 )){
//				attributeObject.name = attributeObject.obj_Nm + '."' + attribute.attrNm + '"';
            attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;
        } else*/

        /*if(objectWrapper.obj_Cd == "DOBJ" &&
                objectWrapper.databaseWrapper.enableExplodeRules) {
            attributeObject.name = attributeObject.obj_Nm + '.' + getExplodeWhereClauseAttributeName(attribute, objectWrapper, '');
        } else if( objectWrapper.obj_Cd == "DOBJIS" &&
                ( objectWrapper.dbTyp_Id == 32 ||
                    objectWrapper.dbTyp_Id == 33 ) &&
                objectWrapper.designWrapper.dbTyp_Id == 21 ) {
            attributeObject.name = attributeObject.obj_Nm + '.' + getExplodeAttributeName(attribute, objectWrapper, '');

        } else if(objectWrapper.obj_Cd == "DOBJIS" &&
                objectWrapper.dbTyp_Id == 30 ) {
        attributeObject.name = attributeObject.obj_Nm + '.' + getExplodeAttributeName(attribute, objectWrapper, '');

        } else if( attributeObject.parent_Attr_Id != -1 )  {
//PERFORMANCE				let parentAttribute = objectWrapper.sub_Ids.get(attributeObject.parent_Attr_Id);
            if( parentAttribute )
                attributeObject.name = attributeObject.obj_Nm + '.' + parentAttribute.attrNm + '.' + attribute.attrNm;
            else
                attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;
        } else {
        attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;
        }

         if( ( objectWrapper.obj_Cd == "DOBJIS" ||
                 objectWrapper.obj_Cd == "DOBJ" ) &&
             objectWrapper.databaseWrapper.enableExplodeRules &&
             attribute.attrDTyp_Id != '12' &&
             attribute.attrDTyp_Id != '11' &&
             attribute.attrDTyp_Id != '33' ) {
            let attributes = objectWrapper.obj_Cd == 'DOBJIS' ? objectWrapper.linkAttributes : objectWrapper.attributes;
            let parentAttribute = getImmediateParentAttribute(attribute, attributes )
            if( parentAttribute &&
                parentAttribute.attrDTyp_Id == '11' ) {
                attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;;
            }
         }

         if( ( objectWrapper.obj_Cd == "DOBJIS" ||
                 objectWrapper.obj_Cd == "DOBJ" ) &&
                 objectWrapper.dbTyp_Id == '30' &&
                 objectWrapper.databaseWrapper.enableExplodeRules &&
                 attribute.attrDTyp_Id == '12') {
             let attributes = objectWrapper.obj_Cd == 'DOBJIS' ? objectWrapper.linkAttributes : objectWrapper.attributes;
             let parentAttribute = getImmediateParentAttribute(attribute, attributes )
             if( parentAttribute &&
                     parentAttribute.attrDTyp_Id == '11' ) {
                 attributeObject.name = attributeObject.obj_Nm + '.' + attribute.attrNm;;
             }
         }	*/

        //PERFORMANCE
        //			if( objectWrapper.obj_Cd == "DOBJIS" &&
        //				objectWrapper.databaseWrapper.enableExplodeRules &&
        //				objectWrapper.designWrapper.dbTyp_Id == 21 &&
        //				attribute.parent_Attr_Id != -1 ) {
        //				attributeObject.parentAttribute = objectWrapper.sub_Ids.get(attribute.parent_Attr_Id);
        //			}

        if (objectWrapper.obj_Cd == "DOBJIS" &&
            objectWrapper.dbTyp_Id == 30 &&
            attribute.parent_Attr_Id != -1) {
            attributeObject.parentAttribute = objectWrapper.sub_Ids.get(attribute.parent_Attr_Id);
        }

        /*if(  objectWrapper.obj_Cd == "DOBJIS" &&
            objectWrapper.dbTyp_Id == 30 &&
            attribute.srcDTypNm == 'record') {
            attributeObject.showUnderline = false;
        }*/


        /*if( objectWrapper.obj_Cd == "DOBJIS" &&
                objectWrapper.databaseWrapper.enableExplodeRules &&
                attribute.attrDTyp_Id == 11 ) {
            let childAttribute = getImmideateChildAttribute(attribute, objectWrapper.linkAttributes )
            if( childAttribute && childAttribute.attrDTyp_Id == '33' && attribute.explodeFlag == 'Y')
            attributeObject.showUnderline = false;
            else
                //attributeObject.showUnderline = true;
        }*/

        /*if( ( objectWrapper.obj_Cd == "DOBJIS" ||
                objectWrapper.obj_Cd == "DOBJ") &&
                objectWrapper.databaseWrapper.enableExplodeRules &&
                attribute.attrDTyp_Id == 11 ) {
            let attributes = objectWrapper.obj_Cd == 'DOBJIS' ? objectWrapper.linkAttributes : objectWrapper.attributes;
            let childAttribute = getImmideateChildAttribute(attribute, attributes )
            if( childAttribute &&
                childAttribute.attrDTyp_Id != '12' &&
                childAttribute.attrDTyp_Id != '11' &&
                childAttribute.attrDTyp_Id != '33' ) {
                if( attribute.explodeFlag == 'Y' )
                    attributeObject.showUnderline = false;
                else
                    attributeObject.showUnderline = true;
            }
        }*/

        /*if( ( objectWrapper.obj_Cd == "DOBJIS" ||
                objectWrapper.obj_Cd == "DOBJ") &&
                objectWrapper.dbTyp_Id == '30' &&
                objectWrapper.databaseWrapper.enableExplodeRules &&
                attribute.attrDTyp_Id == 11 ) {
            let attributes = objectWrapper.obj_Cd == 'DOBJIS' ? objectWrapper.linkAttributes : objectWrapper.attributes;
            let childAttribute = getImmideateChildAttribute(attribute, attributes )
            if( childAttribute &&
                    childAttribute.attrDTyp_Id == '12' ) {
                if( attribute.explodeFlag == 'Y' )
                attributeObject.showUnderline = false;
            else
                attributeObject.showUnderline = true;
        }
        }

    /*	if( ( objectWrapper.obj_Cd == "DOBJIS" ||
                objectWrapper.obj_Cd == "DOBJ") &&
                objectWrapper.databaseWrapper.enableExplodeRules  ) {
            let parentAttribute = objectWrapper.sub_Ids.get(attribute.parent_Attr_Id);
            if( parentAttribute &&
                    parentAttribute.attrDTyp_Id == '11' ) {
                if( parentAttribute.explodeFlag == 'Y' )
                    attributeObject.showUnderline = true;
                else
                    attributeObject.showUnderline = false;
            }
        }

        /*if( (attribute.attrDTyp_Id == 22 ||
                attribute.attrDTyp_Id == 33) &&
                attribute.explodeFlag == 'Y' ) {
            attributeObject.showUnderline = false;
        } */

        /*if( attributeObject.parentAttribute &&
                attributeObject.parentAttribute.attrDTyp_Id == 22 &&
                attributeObject.parentAttribute.explodeFlag == 'N' ) {
            attributeObject.showUnderline = false;
        } */

        attributeObject.type = attribute.attrType_Cd;

        if (nativeDbTyp_Id == undefined ||
            nativeDbTyp_Id == -1) {
            nativeDbTyp_Id = objectWrapper.nativeDbTyp_Id == -2 || objectWrapper.nativeDbTyp_Id == -6 || objectWrapper.obj_Cd == 'DOBJIS' ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id;
        }

        attributeObject.attrDTyp_Id = attribute.attrDTyp_Id;
        attributeObject.attrPrec = attribute.attrPrec;
        attributeObject.attrScale = attribute.attrScale;
        attributeObject.attrDTyp_Name = this.databaseWrappersFactory.getDatatypeName(nativeDbTyp_Id, attribute.attrDTyp_Id);
        attributeObject.attrDesc = AttributesUtil.getInstance().getAttributeType(nativeDbTyp_Id, attribute);

        attributeObject.notNullValue = attribute.notNullFlag != 0;
        //TBD attributeObject.attrKeyTyp_Name = DICollections.getLabel('keyTypes', attribute.attrKeyTyp_Id);

        attributeObject.attrFullDesc = attributeObject.text + ' (' + attributeObject.attrDTyp_Name + ')';

        return attributeObject;
    }





    getFormattedDate(date: Date): string {
        // if (timestamp == -1
        //     || timestamp == undefined) {
        //     timestamp = new Date();
        // }
        // timestamp = new Date("dd-MMM-yyyy HH:mm");
        // return timestamp;
        return '';
    }


    ///--------------------------------------------------
    packRest_PropertiesNames(list: Array<any>, field: string, objectWrapper: ObjectWrapper, type: string): void {
        if (type == 'restParameters') {
            for (let i = 0; i < list.length; i++) {
                objectWrapper.subRestParamsNames.push((list[i][field]).toUpperCase());
            }
        }
        else if (type == 'restHeaders') {
            for (let i = 0; i < list.length; i++) {
                let header: string = list[i][field].toUpperCase()
                objectWrapper.subRestHeadersNames.push(header);
            }
        }
        else if (type == 'metaDataProperties') {
            for (let i = 0; i < list.length; i++) {
                objectWrapper.subMetaDataPropertiesNames.push((list[i][field]).toUpperCase());
            }
        }
        else if (type == 'restFilters') {
            for (let i = 0; i < list.length; i++) {
                objectWrapper.subFiltersNames.push((list[i][field]).toUpperCase());
            }
        }
    }


    packOptionsClausePropertiesNames(list: Array<any>, field: string, objectWrapper: ObjectWrapper): void {
        for (let i = 0; i < list.length; i++) {
            objectWrapper.subOptionClauseNames.push((list[i][field]).toUpperCase());
        }

    }
    packsubKafkaFilterColumnNames(list: Array<any>, field: string, objectWrapper: ObjectWrapper): void {
        for (let i = 0; i < list.length; i++) {
            objectWrapper.subKafkaFilterColumnNames.push((list[i][field]).toUpperCase());
        }

    }
    rename(oldName: string, newName: string, objectWrapper: ObjectWrapper): void {      // TBD
        let index = objectWrapper.subNames.indexOf(oldName);
        if (index == -1) return;

        objectWrapper.subNames.splice(index, 1);
        objectWrapper.subNames.push(newName);
    }

    oldObjValue = '';
    subObjNmFocus(subObject: any, nameField: string): void {
        setTimeout(() => {
            this.oldObjValue = subObject[nameField]
        }, 50);
    }

    subObjNmOldValueReturn(subObject: any, nameField: string, objectWrapper: ObjectWrapper): void {
        if (this.hasWhiteSpace(subObject[nameField])) {
            subObject[nameField] = this.oldObjValue;
            return;
        }

        if (subObject[nameField] == "" || subObject[nameField] == null)
            subObject[nameField] = this.oldObjValue;

        if (subObject.hasOwnProperty('schemaParamNm'))
            subObject.schemaParamNm = this.wrapperUtil.updateSchemaParamName(objectWrapper, subObject);

        if (subObject.hasOwnProperty('dbParamNm'))
            subObject.dbParamNm = this.wrapperUtil.updateDbParamNm(objectWrapper, subObject);
    }

    subObjNmBlur(subObject: any, nameField: string, subObjects: Array<any>, objectWrapper: ObjectWrapper, srt_Order: number): void {
        setTimeout(() => {

            /*if(hasWhiteSpace(subObject[nameField])) {
                subObject[nameField] = oldObjValue;
                return;
            }*/

            let index: number;
            let subObjNmUC = (subObject[nameField]).toUpperCase();
            let oldObjNmUC = this.oldObjValue.toUpperCase();
            if (oldObjNmUC == subObjNmUC) return;

            if (nameField != 'nm') {
                index = objectWrapper.databaseNms.indexOf(subObjNmUC);
            } else {
                index = objectWrapper.conn_DbNms.indexOf(subObjNmUC);
            }

            if (nameField != 'databaseNm' && index != -1) {
                subObject[nameField] = this.oldObjValue;
                return;
            }

            if (subObjNmUC == "") {
                this.subObjNmOldValueReturn(subObject, nameField, objectWrapper)
            }

            index = subObjects.indexOf(oldObjNmUC);
            if (index != -1) subObjects.splice(index, 1, subObjNmUC);

            if (subObject.hasOwnProperty('schemaParamNm'))
                subObject.schemaParamNm = this.wrapperUtil.updateSchemaParamName(objectWrapper, subObject);

            if (subObject.hasOwnProperty('dbParamNm'))
                subObject.dbParamNm = this.wrapperUtil.updateDbParamNm(objectWrapper, subObject);

            //TBD if (DMWFactory.isDMW) {
            //     $rootScope.$broadcast('DMW_ADD_DATABASES_EVENT', [subObject], 'Update');
            // }

            objectWrapper.doValidate();
        });
    }

    addRestPropertieName(propertieName: string, objectWrapper: ObjectWrapper, subObject: string): void {
        propertieName = propertieName.toUpperCase();

        if (subObject == 'restParameters') {
            if (objectWrapper.subRestParamsNames.indexOf(propertieName) != -1) return;
            objectWrapper.subRestParamsNames.push(propertieName);
        }
        else if (subObject == 'restHeaders') {
            if (objectWrapper.subRestHeadersNames.indexOf(propertieName) != -1) return;
            objectWrapper.subRestHeadersNames.push(propertieName);
        } else if (subObject == 'filterProperties') {
            if (objectWrapper.subFiltersNames.indexOf(propertieName) != -1) return;
            objectWrapper.subFiltersNames.push(propertieName);
        }
        else if (subObject == 'metaDataProperties') {
            if (objectWrapper.subMetaDataPropertiesNames.indexOf(propertieName) != -1) return;
            objectWrapper.subMetaDataPropertiesNames.push(propertieName);
        }
    }

    removeRestPropertieName(propertieName: string, objectWrapper: ObjectWrapper, subObject: string): void {
        propertieName = propertieName.toUpperCase();

        if (subObject == 'restParameters') {
            let index = objectWrapper.subRestParamsNames.indexOf(propertieName);
            if (index == -1) return;

            objectWrapper.subRestParamsNames.splice(index, 1);
        }
        else if (subObject == 'restHeaders') {
            let index = objectWrapper.subRestHeadersNames.indexOf(propertieName);
            if (index == -1) return;

            objectWrapper.subRestHeadersNames.splice(index, 1);
        }
        else if (subObject == 'filterProperties') {
            let index = objectWrapper.subFiltersNames.indexOf(propertieName);
            if (index == -1) return;

            objectWrapper.subFiltersNames.splice(index, 1);
        }
        else if (subObject == 'metaDataProperties') {
            let index = objectWrapper.subMetaDataPropertiesNames.indexOf(propertieName);
            if (index == -1) return;

            objectWrapper.subMetaDataPropertiesNames.splice(index, 1);
        }
    }



    getObjectNameLength(objectWrapper: ObjectWrapper): number {
        if (objectWrapper.obj_Cd == 'LPST') {
            return 122;
        }

        if (TransformsUtil.getInstance().isTransform(objectWrapper.obj_Cd, false)) {
            return 50;
        }

        if (objectWrapper.obj_Cd == 'DXMP' && objectWrapper.reusableFlag != 'Y') {
            return 50;
        }

        if (objectWrapper.obj_Cd == 'FILEEVENT' || objectWrapper.obj_Cd == 'EMAILACTION' || objectWrapper.obj_Cd == 'CALNDR' || objectWrapper.obj_Cd == 'TGRP'
            || objectWrapper.obj_Cd == 'CMDTASK' || objectWrapper.obj_Cd == 'SCH_FILEWATCHER' || objectWrapper.obj_Cd == 'NSEQ' || objectWrapper.obj_Cd == 'UDF'
            || objectWrapper.obj_Cd == 'DBFN' || objectWrapper.obj_Cd == 'CONN') {
            return 50;
        }

        return 128;
    }
    //check


    attrDTyp_IdChanged(subObject, subObjects, objectWrapper, oldAttrDTyp_Id) {
        let oldDatatype = this.databaseWrappersFactory.getDatatype(objectWrapper.nativeDbTyp_Id, oldAttrDTyp_Id);
        if (oldDatatype.additionalRows != '') {
            let childAttributes = this.getChildAttributes(subObject, subObjects);
            this.remove(childAttributes, 'attr_Id', 'attrNm', subObjects, objectWrapper);
        }

        let datatype = this.databaseWrappersFactory.getDatatype(objectWrapper.nativeDbTyp_Id, subObject.attrDTyp_Id);
        if (!datatype) return;
        if (datatype && datatype.additionalRows == '') return;

        //			if( objectWrapper.obj_Cd != 'DOBJIS' && objectWrapper.obj_Cd != 'DOBJ' ) return;

        let additionalRows = parseInt(datatype.additionalRows);
        for (let i = 0; i < additionalRows; i++) {
            // let subObjectNew = angular.copy(EmptyObjectsFactory.attribute);
            let subObjectNew = new Attribute();
            subObjectNew.obj_Id = objectWrapper.obj_Id;
            subObjectNew.attr_Id = this.getNewSub_Id(objectWrapper);
            subObjectNew.attrNm = this.util.getNewName(this.getAdditionalAttrNm(datatype, i, subObject.attrNm), objectWrapper.subNames)

            let datatypeTmp = this.databaseWrappersFactory.getDefaultDatatype(objectWrapper.nativeDbTyp_Id);
            if (datatypeTmp) {
                subObjectNew.attrDTyp_Id = datatypeTmp.id;
                subObjectNew.attrPrec = datatypeTmp.defaultprecision;
                subObjectNew.attrScale = datatypeTmp.defaultscale;
            }

            subObjectNew.attrType_Cd = 'ATTR';
            subObjectNew.valid_Cd = '0';

            subObjectNew.clevel = subObject.clevel + 20;
            subObjectNew.parent_Attr_Id = subObject.attr_Id;

            subObjectNew.srt_Order = subObject.srt_Order + i + 1;
            this.setAttributeReadOnlyProperties(subObjectNew, objectWrapper);

            this.insertAt(subObjectNew, 'attr_Id', 'attrNm', subObjectNew.srt_Order, subObjects, objectWrapper, subObjectNew.clevel);
        }
    }

    setAttributeReadOnlyProperties(attribute, objectWrapper) {
        let datatype = this.databaseWrappersFactory.getDatatype(objectWrapper.nativeDbTyp_Id, attribute.attrDTyp_Id);
        if (!datatype) return '';

        attribute.attrDTypNm = datatype.name;
        attribute.showAttrPrec = datatype.enableprecision != 'n';
        attribute.showAttrScale = datatype.enablescale != 'n';
        attribute.showExplodeFlg = datatype.enableexplode != 'n';
        attribute.maxAttrPrec = datatype.maxprec;
        attribute.maxAttrScale = datatype.maxscale;

        // let valueHMap = DICollections.valuesHMap['keyTypes'];
        let valueHMap = new Map();
        if (valueHMap) {
            let label = valueHMap[attribute.attrKeyTyp_Id];
            if (!label)
                attribute.attrKeyTypLabel = '';
            else
                attribute.attrKeyTypLabel = label;
        } else {
            attribute.attrKeyTypLabel = '';
        }

        attribute.hideAttrDTyp_Id = objectWrapper.databaseWrapper.hideAttrDTyp_Id(attribute);
        attribute.hideNotNullFlag = objectWrapper.databaseWrapper.hideNotNullFlag(attribute);
        attribute.hideAttrKeyTyp_Id = objectWrapper.databaseWrapper.hideAttrKeyTyp_Id(attribute);
        attribute.hideDistKeyFlag = objectWrapper.databaseWrapper.hideDistKeyFlag(attribute);
        attribute.hideOrderBy = objectWrapper.databaseWrapper.hideOrderBy(attribute);
        attribute.hideOccurs = objectWrapper.databaseWrapper.hideOccurs(attribute);
        attribute.hideDependingOn = objectWrapper.databaseWrapper.hideDependingOn(attribute);
        attribute.hideSigned = objectWrapper.databaseWrapper.hideSigned(attribute);
        attribute.hideTsigned = objectWrapper.databaseWrapper.hideTsigned(attribute);
        attribute.hideIsigned = objectWrapper.databaseWrapper.hideIsigned(attribute);
        attribute.hideRdeci = objectWrapper.databaseWrapper.hideRdeci(attribute);
        attribute.error_Msg = this.getError_Msg(attribute.valid_Cd);
    }

    getAdditionalAttrNm(dataType, index, attrNm) {
        let additionalNames = String(dataType.additionalNames).split(',');

        if (additionalNames.length == 1 && additionalNames[0] == 'ARRAY') {
            return "__" + attrNm;
        }

        if (additionalNames.length > index)
            return additionalNames[index] == "" ? attrNm : additionalNames[index]

        return attrNm;
    }

    getChildAttributes(parentAttribute, attributes) {
        let attr_Ids = [];
        attr_Ids.push(parentAttribute.attr_Id);

        let childAttributes = [];
        for (let i = parentAttribute.srt_Order + 1; i < attributes.length; i++) {
            let attribute = attributes[i];

            if (attr_Ids.indexOf(attribute.parent_Attr_Id) == -1) break;
            childAttributes.push(attribute);

            if (attr_Ids.indexOf(attribute.attr_Id) != -1) continue;
            attr_Ids.push(attribute.attr_Id);
        }

        return childAttributes;
    }



    resetDobj_Id(list, index) {
        if (index == undefined) index = 0;

        for (let i = index; i < list.length; i++) {
            list[i].dobj_Id = i;
        }
    }

    venn_Grp_ResetSrt_Order(list, index) {
        if (index == undefined) index = 0;

        for (let i = index; i < list.length; i++) {
            list[i].srt_Order = i;
        }
    }

    getNewVenn_Grp_Id(objectWrapper) {
        if (objectWrapper.newVenn_Grp_Id == -1) {
            objectWrapper.newVenn_Grp_Id = 0;
        }

        return ++objectWrapper.newVenn_Grp_Id;
    }

    getNewMJnr_Inst_Cnd_Id(objectWrapper) {
        if (objectWrapper.newMJnr_Inst_Cnd_Id == -1) {
            objectWrapper.newMJnr_Inst_Cnd_Id = 0;
        }

        return ++objectWrapper.newMJnr_Inst_Cnd_Id;
    }

    getTransformObject(objectWrapper: ObjectWrapper, text: string = '') {
        let transformObject: any = {};

        transformObject.objectName = objectWrapper.objectName;

        transformObject.obj_Id = objectWrapper.obj_Id;
        transformObject.text = text != '' ? text : objectWrapper.name;
        transformObject.name = objectWrapper.name;
        transformObject.obj_Cd = objectWrapper.obj_Cd;

        transformObject.dbTyp_Id = objectWrapper.dbTyp_Id;
        transformObject.nativeDbTyp_Id = objectWrapper.nativeDbTyp_Id;

        transformObject.imageUrl = objectWrapper.imageUrl;

        transformObject.expanded = true;

        transformObject.items = new Array<any>();

        return transformObject;
    }


    getExplodeWhereClauseAttributeName(attribute, objectWrapper, name) {
        name = name == "" ? attribute.attrNm : name;
        if (attribute.parent_Attr_Id == -1) return name;

        let parentAttribute = this.getImmediateParentForAvroAttribute(attribute, objectWrapper.attributes)
        name = parentAttribute.attrNm + '.' + name;

        if (parentAttribute.parent_Attr_Id != -1) {
            return this.getExplodeWhereClauseAttributeName(parentAttribute, objectWrapper, name);
        }

        return name;
    }

    getExplodeAttributeName(attribute, objectWrapper, name) {
        name = name == "" ? attribute.attrNm : name;
        if (attribute.parent_Attr_Id == -1) return name;

        let parentAttribute = this.getImmediateParentForAvroAttribute(attribute, objectWrapper.linkAttributes)
        if (objectWrapper.dbTyp_Id == '30' &&
            parentAttribute.attrDTyp_Id == 33 &&
            parentAttribute.parent_Attr_Id != -1) {
            return this.getExplodeAttributeName(parentAttribute, objectWrapper, name);
        }
        if (objectWrapper.dbTyp_Id == '30' &&
            parentAttribute.attrDTyp_Id == 33 &&
            parentAttribute.parent_Attr_Id == -1) {
            name = parentAttribute.attrNm + '_' + name;
        } else {
            if (parentAttribute.explodeFlag == 'N') {
                name = parentAttribute.attrNm + '.' + name;
            } else if (objectWrapper.dbTyp_Id == '30' &&
                parentAttribute.parent_Attr_Id != -1) {
                name = name;
            } else
                name = parentAttribute.attrNm + '_' + name;
        }

        if (parentAttribute.parent_Attr_Id != -1) {
            return this.getExplodeAttributeName(parentAttribute, objectWrapper, name);
        }

        return name;
    }

    getRecordTypeName(attribute, attributes, name) {
        name = name == "" ? attribute.attrNm : name;
        if (attribute.parent_Attr_Id == -1) return name;

        let parentAttribute = this.getImmediateParentAttribute(attribute, attributes)
        name = parentAttribute.attrNm + '_' + name;

        if (parentAttribute.parent_Attr_Id != -1) {
            return this.getRecordTypeName(parentAttribute, attributes, name);
        }

        return name;
    }

    getImmideateChildAttribute(selectedAttribute, attributes, transformObject, objectWrapper) {
        if (objectWrapper) {
            return attributes = objectWrapper.carryForwardAttributesHMapIds.get(transformObject.obj_Id + '-' + selectedAttribute.attr_Id);
        } else {
            for (let i = 0; i < attributes.length; i++) {
                let attribute = attributes[i];
                if (attribute.parent_Attr_Id != selectedAttribute.attr_Id) continue;
                return attribute;
            }
        }

        return null;

    }

    getLAttributeObject(lAttribute, objectWrapper: ObjectWrapper) {
        let lAttributeObject: any = {};
        lAttributeObject.obj_Id = objectWrapper.obj_Id;
        lAttributeObject.obj_Nm = objectWrapper.name;
        lAttributeObject.attr_Id = lAttribute.lAttr_Id;
        lAttributeObject.dTyp_Attr_Id = lAttribute.dTyp_Attr_Id;
        lAttributeObject.text = lAttribute.lAttrNm;
        lAttributeObject.name = objectWrapper.name + '.' + lAttributeObject.text;
        lAttributeObject.type = 'L';

        lAttributeObject.lnk_Obj_Inst_Id = lAttribute.lnk_Obj_Inst_Id;
        lAttributeObject.lnk_Attr_Id = lAttribute.lnk_Attr_Id;
        lAttributeObject.showUnderline = true;

        return lAttributeObject;
    }



    getParentAttribute(attribute, attributes) {
        let parentAttribute = attribute;

        for (let i = 0; i < attributes.length; i++) {
            let attribute1 = attributes[i];
            if (attribute1.attr_Id == attribute.parent_Attr_Id) {
                if (attribute1.parent_Attr_Id != -1) {
                    return this.getParentAttribute(attribute1, attributes);
                } else
                    return attribute1;
            }
        }
        return parentAttribute;
    }

    getImmediateParentForAvroAttribute(selectedAttribute, attributes) {
        if (selectedAttribute.parent_Attr_Id == -1) return selectedAttribute;

        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (attribute.attr_Id != selectedAttribute.parent_Attr_Id) continue;

            if (attribute.attrDTyp_Id == 33) {
                let ImidiateParentAttribute = this.getImmediateParentAttribute(attribute, attributes);
                if (ImidiateParentAttribute.attrDTyp_Id == 11) {
                    return this.getImmediateParentForAvroAttribute(attribute, attributes);
                }
            }
            return attribute;
        }
    }

    getImmediateParentAttribute(selectedAttribute, attributes) {
        if (selectedAttribute.parent_Attr_Id == -1) return selectedAttribute;

        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (attribute.attr_Id != selectedAttribute.parent_Attr_Id) continue;
            return attribute;
        }
    }

    getImmediateChildAttributes(parentAttribute, attributes) {


        let immediateChildAttributes = [];

        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (attribute.parent_Attr_Id != parentAttribute.attr_Id) continue;

            immediateChildAttributes.push(attribute);
        }

        return immediateChildAttributes;
    }

    setParameterReadOnlyProperties(objectWrapper, paramTyp) {

        let datatype = this.databaseWrappersFactory.getDefaultDatatype(objectWrapper.dbTyp_Id);
        if (datatype) {
            paramTyp.paramDTyp_Id = datatype.id;
            paramTyp.paramPrec = datatype.defaultprecision;
            paramTyp.paramScale = datatype.defaultscale;
        }
    }

    getParamCarryForwardObject(param, objectWrapper) {
        let paramObject: AttributeCarryForward = new AttributeCarryForward();

        paramObject.obj_Nm = param.paramTyp == 'P' ? "Param" : "SQL Param";

        paramObject.obj_Id = objectWrapper.obj_Id;
        paramObject.attr_Id = param.param_Id;
        paramObject.attrFullNm = (param.paramTyp == 'P' ? "$MP_" : "$SP_") + param.nm;
        paramObject.attrNm = paramObject.attrFullNm;
        paramObject.attrType_Cd = param.paramTyp;
        paramObject.attrDTyp_Id = param.paramDTyp_Id;
        paramObject.attrDTypNm = this.databaseWrappersFactory.getDatatypeName(objectWrapper.dbTyp_Id, param.paramDTyp_Id);
        paramObject.attrPrec = param.paramPrec;
        paramObject.attrScale = param.paramScale;
        paramObject.text = paramObject.attrFullNm; //param.nm;
        paramObject.type = param.paramTyp;
        paramObject.attrDesc = this.databaseWrappersFactory.getParamType(objectWrapper.nativeDbTyp_Id, param);
        paramObject.name = paramObject.attrFullNm;
        paramObject.paramDTyp_Name = this.databaseWrappersFactory.getDatatypeName(objectWrapper.dbTyp_Id, param.paramDTyp_Id);

        paramObject.parent_Attr_Id = -1;;
        paramObject.explodeFlag = '';
        paramObject.clevel = -1;
        paramObject.notNullValue = false;
        paramObject.showUnderline = false;
        paramObject.attrKeyTyp_Id = -1;
        paramObject.attrKeyTyp_Name = '';
        paramObject.notNullFlag = 0;
        paramObject.lnk_Obj_Id = -1;
        paramObject.lnk_Attr_Id - 1;
        paramObject.checked = 'false';

        return paramObject;
    }

    getParamObject(param, objectWrapper) {

        let paramObject: ParamObj = new ParamObj();

        paramObject.objectName = param.paramTyp == 'P' ? "Param" : "SQL Param";

        paramObject.obj_Id = objectWrapper.obj_Id;
        paramObject.param_Id = param.param_Id;
        paramObject.name = (param.paramTyp == 'P' ? "$FL_" : "$FS_") + param.nm;
        paramObject.text = paramObject.name

        paramObject.paramType_Cd = param.paramTyp;
        paramObject.paramDTyp_Id = param.paramDTyp_Id;
        paramObject.paramPrec = param.paramPrec;
        paramObject.paramScale = param.paramScale;

        paramObject.paramDesc = this.databaseWrappersFactory.getParamType(objectWrapper.nativeDbTyp_Id, param);
        paramObject.paramDTyp_Name = this.databaseWrappersFactory.getDatatypeName(objectWrapper.dbTyp_Id, param.paramDTyp_Id);

        paramObject.icon = 'icon-parameter';

        return paramObject;
    }

    updateLAttributeObjects(lAttributeObjects, designWrapper) {
        let attributesHMapIDs = [];
        for (let i = 0; i < designWrapper.transformWrappers.length; i++) {
            let transformWrapper = designWrapper.transformWrappers[i];

            if (transformWrapper.linkAttributes) {
                for (let j = 0; j < transformWrapper.linkAttributes.length; j++) {
                    let attribute = transformWrapper.linkAttributes[j];
                    attributesHMapIDs[transformWrapper.obj_Id + '-' + attribute.attr_Id] = attribute;
                }
            }

            if (transformWrapper.lAttributes) {
                for (let j = 0; j < transformWrapper.lAttributes.length; j++) {
                    let lAttribute = transformWrapper.lAttributes[j];
                    attributesHMapIDs[transformWrapper.obj_Id + '-' + lAttribute.lAttr_Id] = lAttribute;
                }
            }

            if (transformWrapper.attributes) {
                for (let j = 0; j < transformWrapper.attributes.length; j++) {
                    let attribute = transformWrapper.attributes[j];
                    attributesHMapIDs[transformWrapper.obj_Id + '-' + attribute.attr_Id] = attribute;
                }
            }
        }

        for (let i = 0; i < lAttributeObjects.length; i++) {
            let lAttributeObject = lAttributeObjects[i];

            let attribute = this.getAttributeRecursion(lAttributeObject.lnk_Obj_Inst_Id, lAttributeObject.lnk_Attr_Id, attributesHMapIDs);
            if (!attribute) continue;

            lAttributeObject.attrDTyp_Id = attribute.attrDTyp_Id;
            lAttributeObject.attrPrec = attribute.attrPrec;
            lAttributeObject.attrScale = attribute.attrScale;

            lAttributeObject.notNullValue = attribute.notNullFlag != 0;
            //TBD lAttributeObject.attrKeyTyp_Name = DICollections.getLabel('keyTypes', attribute.attrKeyTyp_Id);

            lAttributeObject.attrDTyp_Name = this.databaseWrappersFactory.getDatatypeName(designWrapper.nativeDbTyp_Id, attribute.attrDTyp_Id);
            lAttributeObject.attrDesc = AttributesUtil.getInstance().getAttributeType(designWrapper.nativeDbTyp_Id, attribute);

            lAttributeObject.attrFullDesc = lAttributeObject.text + ' (' + lAttributeObject.attrDTyp_Name + ')';
        }
    }

    getAttributeRecursion(lnk_Obj_Inst_Id, lnk_Attr_Id, attributesHMapIDs) {
        let attribute = attributesHMapIDs[lnk_Obj_Inst_Id + '-' + lnk_Attr_Id];
        if (!attribute) return null;

        if (attribute.hasOwnProperty('lAttr_Id'))
            return this.getAttributeRecursion(attribute.lnk_Obj_Inst_Id, attribute.lnk_Attr_Id, attributesHMapIDs);

        return attribute;
    }

    validateEmail(email) {
        return /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4};?)+$/.test(email);
    }

    validatePassword(password) {
        return /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@\_%&\*])(?=.{8,})/.test(password);
    }

    hasWhiteSpace(name: string): any {
        return !(/^\w+$/.test(name));
    }

    validateMobileNumber(mobileNumber) {
        return /^[0-9\)\(\-]*$/.test(mobileNumber);
    }

    validateGroupName(name) {
        let specialChars = "<>@!#$%^&*()+[]{}?:;|'\"\\,./~`-=";
        for (let i = 0; i < specialChars.length; i++) {
            if (name.indexOf(specialChars[i]) > -1) {
                let groupname = name.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                return groupname;
            }
        }
        return name;
    }

    replaceWhiteSpaceToUnderScore(name) {
        return name.replace(/ /g, "_") ///\s/g.test(name);
    }

    isAttributeNameValidate(name) {
        return /\s+$/g.test(name);
    }

    validateMsg = "";
    checkNmValidate(field, value) {
        if (value == " ") {
            this.validateMsg = "Enter '" + field + "'";
        } else
            this.validateMsg = "";

        if (this.hasWhiteSpace(value)) {
            this.validateMsg = "'" + field + "' should not contain any black spaces"
        } else
            this.validateMsg = "";
    }

    isExistWithNm(value, list, field) {
        let listLength = list.length;

        for (let i = 0; i < listLength; i++) {
            let item = list[i];
            if (item[field].indexOf(value) == -1) continue;
            return false;
        }
        return true;
    }

    getError_Msg(error_Cd: string): string {
        if (error_Cd == '0') return '';

        let error_Msg: string = ErrorCdsEnums.errorcds[error_Cd];
        if (error_Msg) return error_Msg;

        return error_Cd;
    }

    selectTransOrJob(objectWrappers, objectWrapper) {

        let objectWrapperLen = objectWrappers.length;
        for (let i = 0; i < objectWrapperLen; i++) {
            objectWrappers[i].isSelected = false;
        }

        if (objectWrapper)
            objectWrapper.isSelected = true;
    }



    fillELProperties(conn_Id, fldr_Id, object, connection, type) {
        //TBD let connection = connection;
        // if (!connection) {
        //     let diMsgObjectEmpty = ListFactory.setSelectedObjectList(conn_Id, 'CONN');
        //     StudioServiceManagerFactory.openListObjects(fldr_Id, diMsgObjectEmpty, true).then(function (diMsgObject) {
        //         connection = diMsgObject.retMsgObjects[0];
        //     });
        // }

        // $timeout(function () {
        //     if (type == 'E') {
        //         object.extractPropertyTypes = connection.extractPropertyTypes;
        //         object.sel_Extract_PropertyType_Cd = connection.sel_Extract_PropertyType_Cd;
        //         // object.extract_Properties = new kendo.data.ObservableArray(connection.extract_Properties);
        //     }
        //     if (type == 'L') {
        //         object.loadPropertyTypes = connection.loadPropertyTypes;
        //         object.sel_Load_PropertyType_Cd = connection.sel_Load_PropertyType_Cd;
        //         object.load_Properties = new kendo.data.ObservableArray(connection.load_Properties);
        //     }
        // }, 350);

    }

    isDateValidate(date) {
        return /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(date);
    }

    isTimeValidate(time) {
        return /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
    }

    isShowELproperties(parentObject: any, object: any, obj_Cd: string): boolean {
        let databaseWrapper: DatabaseWrapper;
        if (obj_Cd == CommonEnums.codes.DESIGN) {
            databaseWrapper = this.databaseWrappersFactory.getDatabaseWrapper(parentObject.dxMp.nativeDbTyp_Id);
        } else if (obj_Cd == CommonEnums.codes.STREAM) {
            databaseWrapper = this.databaseWrappersFactory.getDatabaseWrapper(parentObject.dxMp_Inst.dbTyp_Id);
        }

        if (!databaseWrapper) return;

        if (obj_Cd == CommonEnums.codes.DESIGN &&
            parentObject.dxMp.nativeDbTyp_Id == DatabaseEnum.spark.ID) {
            if (databaseWrapper.nativeDbTyp_Ids.indexOf(object.dObj.dbTyp_Id) != -1)
                return true;
        }

        if (obj_Cd == CommonEnums.codes.DESIGN &&
            parentObject.dxMp.nativeDbTyp_Id == DatabaseEnum.hive.ID &&
            (databaseWrapper.nativeDbTyp_Ids.indexOf(object.dObj.dbTyp_Id) != -1)) {
            return this._isNativeOrExternal(parentObject, object, obj_Cd);
        }


        if (obj_Cd == CommonEnums.codes.DESIGN &&
            object.dObj.dbTyp_Id != parentObject.dxMp.nativeDbTyp_Id) {
            return false;
        }

        if (obj_Cd == CommonEnums.codes.STREAM &&
            parentObject.dxMp_Inst.dbTyp_Id == DatabaseEnum.spark.ID) {
            if (databaseWrapper.nativeDbTyp_Ids.indexOf(object.dbTyp_Id) != -1)
                return true;
        }


        if (obj_Cd == CommonEnums.codes.STREAM &&
            parentObject.dxMp_Inst.dbTyp_Id == DatabaseEnum.hive.ID &&
            (databaseWrapper.nativeDbTyp_Ids.indexOf(object.dbTyp_Id) != -1)) {
            return this._isNativeOrExternal(parentObject, object, obj_Cd);
        }


        if (obj_Cd == CommonEnums.codes.STREAM &&
            object.dbTyp_Id != parentObject.dxMp_Inst.dbTyp_Id) {
            return false;
        }


        if ((obj_Cd == CommonEnums.codes.DESIGN && (parentObject.dxMp.nativeDbTyp_Id == -2 || parentObject.dxMp.nativeDbTyp_Id == -6)) ||
            (obj_Cd == CommonEnums.codes.STREAM && (parentObject.dxMp_Inst.dbTyp_Id == -2 || parentObject.dxMp_Inst.dbTyp_Id == -6))) {
            return false;
        }

        return this._isNativeOrExternal(parentObject, object, obj_Cd);
    }

    _isNativeOrExternal(parentObject: any, object: any, obj_Cd: string): boolean {
        let parent: any = {};
        let dependentObject: any = {};

        if (parentObject.repConn.conn.dbTyp_Id == DatabaseEnum.hive.ID &&
            parentObject.repConn.conn.hiveServe2HACnf_Flg == 'Y') {
            parent.zookeeper_Quorum_Host = parentObject.repConn.conn.zookeeper_Quorum_Host;
        } else {
            parent.host = parentObject.repConn.conn.host;
            parent.port = parentObject.repConn.conn.port;
            parent.conn_Usr = parentObject.repConn.conn_Usr.conn_Usr;
            parent.secKeyTab = parentObject.repConn.conn.secKeyTab;
            parent.platform = parentObject.repConn.conn.platform;
        }

        if (parentObject.repConn.conn.dbTyp_Id == DatabaseEnum.mssql.ID &&
            parentObject.repConn.conn.connType != 'Azure SQL Database') {
            parent.instSqlNm = parentObject.repConn.conn.instSqlNm;
        }

        if (obj_Cd == CommonEnums.codes.STREAM) {
            if (object.dbTyp_Id == DatabaseEnum.hive.ID &&
                object.hiveServe2HACnf_Flg == 'Y') {
                dependentObject.zookeeper_Quorum_Host = object.zookeeper_Quorum_Host;
            } else {
                dependentObject.host = object.host;
                dependentObject.port = object.port;
                dependentObject.conn_Usr = object.conn_Usr;
                dependentObject.secKeyTab = object.secKeyTab;
                dependentObject.platform = object.platform;
            }
            if (object.dbTyp_Id == DatabaseEnum.mssql.ID &&
                object.connType != 'Azure SQL Database') {
                    dependentObject.instSqlNm = object.instSqlNm;
            }
        } else {
            if ((object.dObj.dbTyp_Id == DatabaseEnum.hive.ID ||
                object.dObj.dbTyp_Id == DatabaseEnum.dfs.ID) &&
                object.dObj.hiveServe2HACnf_Flg == 'Y') {
                dependentObject.zookeeper_Quorum_Host = object.dObj.zookeeper_Quorum_Host;
            } else {
                dependentObject.host = object.dObj.host;
                dependentObject.port = object.dObj.port;
                dependentObject.conn_Usr = object.dObj.conn_Usr;
                dependentObject.secKeyTab = object.dObj.secKeyTab;
                dependentObject.platform = object.dObj.platform;
            }

            if (object.dObj.dbTyp_Id == DatabaseEnum.mssql.ID &&
                object.dObj.connType != 'Azure SQL Database') {
                    dependentObject.instSqlNm = object.dObj.instSqlNm;
            }

        }

        let parentString = JSON.stringify(parent);
        let objectString = JSON.stringify(dependentObject);
        return parentString == objectString;
    }

    getObj_Db_PropertyKey(property) {

        return property.conn_Id + '-' +
            property.dbTyp_Id + '-' +
            property.el_Type + '-' +
            property.property_Cd + '-' +
            property.propertyType_Cd + '-' +
            property.dxMp_Inst_Id + '-' +
            property.dxFlow_Id;
    }

    addSameJSONRestHeaders(objectWrapper, objects, obj_Cd, rest_Db_Object) {
        if (obj_Cd == 'DXMP') {
            for (let i = 0; i < objects.length; i++) {
                let transformWrapper = objects[i];
                if (transformWrapper.obj_Cd == "DOBJIS" &&
                    transformWrapper.source.src_Inst.group_Id == objectWrapper.source.src_Inst.group_Id &&
                    transformWrapper.obj_Id != objectWrapper.obj_Id) {

                    rest_Db_Object.obj_Id = transformWrapper.obj_Id;
                    transformWrapper.header_Properties.push(rest_Db_Object);
                    this.addRestPropertieName(rest_Db_Object.property_Cd, transformWrapper, "restHeaders");
                    this.resetSrt_Order(transformWrapper.header_Properties, undefined) //index);
                    transformWrapper.setChange_Ind();
                }
            }
        }
    }

    removeSameJSONRestHeaders(selectedRestHeader, objectWrapper, objects, obj_Cd) {
        if (obj_Cd == 'DXMP') {
            for (let k = 0; k < objects.length; k++) {
                let transformWrapper = objects[k];
                if (transformWrapper.obj_Cd == "DOBJIS" &&
                    transformWrapper.source.src_Inst.group_Id == objectWrapper.source.src_Inst.group_Id &&
                    transformWrapper.obj_Id != objectWrapper.obj_Id) {

                    for (let m = 0; m < transformWrapper.header_Properties.length; m++) {
                        let rest_Property = transformWrapper.header_Properties[m];
                        if (rest_Property.srt_Order == selectedRestHeader.srt_Order) {
                            transformWrapper.header_Properties.splice(m, 1);
                            this.removeRestPropertieName(selectedRestHeader.property_Cd, transformWrapper, "restHeaders");
                            m--;
                        }
                    }
                }
                transformWrapper.setChange_Ind();
            }
        }
    }

    changeJSONSourcesProperties(objectWrapper, objects, dataItem, type, conn_Db_Obj_Lnk, obj_Cd, propertyVal) {
        if (obj_Cd == 'DXMP') {
            for (let i = 0; i < objects.length; i++) {
                let transformWrapper = objects[i];
                if (transformWrapper.obj_Cd == "DOBJIS" &&
                    transformWrapper.source.src_Inst.group_Id == objectWrapper.source.src_Inst.group_Id) {

                    let propertiesHMap = [];
                    let properties = [];
                    if (type == 'E') {
                        properties = transformWrapper.extract_Properties;
                    } else if (type == 'L') {
                        properties = transformWrapper.load_Properties;
                    } else if (type == 'H') {
                        properties = transformWrapper.header_Properties;
                    } else if (type == 'P') {
                        properties = transformWrapper.param_Properties;
                    }

                    for (let j = 0; j < properties.length; j++) {
                        let extract_Property = properties[j];
                        let propertyTypeKey = this.getObj_Db_PropertyKey(extract_Property);
                        propertiesHMap[propertyTypeKey] = properties[j];
                    }
                    let property = this.getObj_Db_PropertyKey(dataItem);
                    let extractProperty = propertiesHMap[property];
                    if (extractProperty) {
                        propertiesHMap[property].propertyVal = propertyVal;
                        transformWrapper.doValidate();
                        continue;
                    }

                }
            }
        } else if (obj_Cd == "DXMPI") {
            for (let i = 0; i < objects.length; i++) {
                let object = objects[i];
                if (object.obj_Cd == "DOBJIS" && object.group_Id == conn_Db_Obj_Lnk.group_Id) {
                    let propertiesHMap = [];
                    let properties = [];
                    properties = type == 'E' ? object.extract_Properties : object.load_Properties

                    for (let j = 0; j < properties.length; j++) {
                        let extract_Property = properties[j];
                        let propertyTypeKey = this.getObj_Db_PropertyKey(extract_Property);
                        propertiesHMap[propertyTypeKey] = properties[j];
                    }
                    let property = this.getObj_Db_PropertyKey(dataItem);
                    let extractProperty = propertiesHMap[property];
                    if (extractProperty) {
                        propertiesHMap[property].propertyVal = propertyVal;
                        objectWrapper.doValidate();
                        continue;
                    }
                }
            }
        }

    }

    fillLnkValue(dxFlow_Fwd_Lnk, objectWrapper) {
        //TBD StudioServiceManagerFactory.getSystemParams("RUNTIME_STATUS", objectWrapper.obj_Id, objectWrapper.streamWrapper.stream, true, true).then(function (diMsgObject) {
        //     dxFlow_Fwd_Lnk.lnkCndVal = diMsgObject.retMsgObjects[0].systemParam[0].name + " = 'SUCCEEDED'"
        //     dxFlow_Fwd_Lnk.lnkCndValid_Cd = "0"
        //     objectWrapper.doValidate();
        //     if (objectWrapper.streamWrapper) {
        //         objectWrapper.streamWrapper.doValidate();
        //     }
        // });
    }

    // setLinkCoordinates(link) {
    //     if (!link) return;

    //     link.sourceCoordX = link.fromObjectWrapper.point.x + link.fromObjectWrapper.width - 4;

    //     link.sourceCoordY = link.fromObjectWrapper.point.y + link.fromObjectWrapper.height / 2;
    //     if (link.fromObjectWrapper.showOutList) {
    //         let outList = link.fromObjectWrapper.outList;
    //         let height = 31;

    //         for (let i = 0; i < outList.length; i++) {
    //             if (outList[i].value == link.dxMp_Fwd_Lnk.grp_Id) {
    //                 if (i == 0)
    //                     link.sourceCoordY = link.fromObjectWrapper.point.y + link.fromObjectWrapper.height / 2 + height;
    //                 else
    //                     link.sourceCoordY = link.fromObjectWrapper.point.y + link.fromObjectWrapper.height / 2 + height + (i * 22);

    //                 break;
    //             }
    //         }

    //     }


    //     link.destCoordX = link.toObjectWrapper.point.x;

    //     link.destCoordY = link.toObjectWrapper.point.y + link.toObjectWrapper.height / 2;
    //     if (link.toObjectWrapper.showInList) {
    //         let inList = link.toObjectWrapper.getInList();

    //         if (link.toObjectWrapper.obj_Cd == 'DESRUI') {
    //             for (let i = inList.length - 1; i >= 0; i--) {
    //                 if (inList[i].value == link.dxMp_Fwd_Lnk.fwd_Lnk_Grp_Id) {
    //                     link.destCoordY = link.toObjectWrapper.point.y + link.toObjectWrapper.height / 2 - ((i + 1) * 27);
    //                     break;
    //                 }
    //             }
    //         } else {
    //             for (let i = inList.length - 1; i >= 0; i--) {
    //                 if (inList[i].value == -1) continue;

    //                 if (inList[i].value == link.dxMp_Fwd_Lnk.obj_Id) {
    //                     //						let count = inList.length - i;
    //                     link.destCoordY = link.toObjectWrapper.point.y + link.toObjectWrapper.height / 2 - ((i + 1) * 27);
    //                     break;
    //                 } else if (inList[i].value == -2) {
    //                     //						let count = inList.length - i;
    //                     link.destCoordY = link.toObjectWrapper.point.y + link.toObjectWrapper.height / 2 - ((i + 1) * 32);
    //                     break;
    //                 }
    //             }
    //         }

    //     }

    //     let pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
    //     let pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };

    //     link.sourceTangentX = pt1.x + (pt2.x - pt1.x) / 2;

    //     let pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
    //     link.sourceTangentY = pt1.y;

    //     let pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
    //     let pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };

    //     link.destTangentX = pt2.x - (pt2.x - pt1.x) / 2;

    //     let pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };
    //     link.destTangentY = pt2.y;

    //     link.dotCoordX = (link.sourceCoordX + link.destCoordX - 2) / 2;

    //     link.dotCoordY = (link.sourceCoordY + link.destCoordY) / 2;
    // }

    setMetaviewLinkCoordinates(link) {


        link.sourceCoordX = link.fromObjectWrapper.point.x + link.fromObjectWrapper.width + 74;

        link.sourceCoordY = link.fromObjectWrapper.point.y + link.fromObjectWrapper.height / 2;

        link.destCoordX = link.toObjectWrapper.point.x;

        link.destCoordY = link.toObjectWrapper.point.y + link.toObjectWrapper.height / 2;

        let pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
        let pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };

        link.sourceTangentX = pt1.x + (pt2.x - pt1.x) / 2;

        pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
        link.sourceTangentY = pt1.y;

        pt1 = { 'x': link.sourceCoordX, 'y': link.sourceCoordY };
        pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };

        link.destTangentX = pt2.x - (pt2.x - pt1.x) / 2;

        pt2 = { 'x': link.destCoordX, 'y': link.destCoordY };
        link.destTangentY = pt2.y;

        link.sourceCoordY = link.sourceCoordY + 5;
        link.sourceTangentY = link.sourceTangentY + 5;
        link.destCoordY = link.destCoordY + 5;
        link.destTangentY = link.destTangentY + 5;
    }

    numaricTextBoxBlur(dataItem, field, min, maxField) {
        if (this.oldObjValue == dataItem[field]) return;

        if (dataItem.minAttrPrec != -1) {
            min = dataItem.minAttrPrec;
        }
        if (parseInt(dataItem.attrDTyp_Id) != 3) {//DDS-7073 Scotia-GCP:Cobol data is not loading properly . restricted for cobol
            if (dataItem[field].indexOf('.') != -1) {
                dataItem[field] = this.oldObjValue;
            } else if (dataItem[field] < min ||
                dataItem[field] > dataItem[maxField]) {
                dataItem[field] = this.oldObjValue;
            }
        }

        //DDS-7073 Scotia-GCP:Cobol data is not loading properly . restricted for cobol
        if (parseInt(dataItem.attrDTyp_Id) != 3) {
            if (dataItem.attrPrec < dataItem.attrScale) {
                dataItem[field] = this.oldObjValue;
            }
        }

    }

    //DDS-5168
    numaricTextBoxScableBlur(dataItem, field, min, maxField) {
        if (this.oldObjValue == dataItem[field]) return;

        if (dataItem.minAttrPrec != -1) {
            min = dataItem.minAttrScale;
        }

        if (dataItem[field].indexOf('.') != -1) {
            dataItem[field] = this.oldObjValue;
        } else if (dataItem[field] < min ||
            dataItem[field] > dataItem[maxField]) {
            dataItem[field] = this.oldObjValue;
        }

        //DDS-7073 Scotia-GCP:Cobol data is not loading properly . restricted for cobol
        if (parseInt(dataItem.attrDTyp_Id) != 3) {
            if (parseInt(dataItem.attrPrec) < parseInt(dataItem.attrScale)) {
                dataItem[field] = this.oldObjValue;
            }
        }
    }

    setShortName(name: string): string {
        return name.length > 15 ? name.slice(0, 15) + '...' : name;
    }

    getTransformBy_Id(design, transform_Id) {
        for (let i = 0; i < design.objects.length; i++) {
            if (this.getObjectInst_Id(design.objects[i]) == transform_Id)
                return design.objects[i];
        }

        return null;
    }

    getObjectInst_Id(object) {

        if (object.hasOwnProperty('src_Inst'))
            return object.src_Inst.src_Inst_Id;

        if (object.hasOwnProperty('expr_Inst'))
            return object.expr_Inst.expr_Inst_Id;

        if (object.hasOwnProperty('tgt_Inst'))
            return object.tgt_Inst.tgt_Inst_Id;

        if (object.hasOwnProperty('fltr_Inst'))
            return object.fltr_Inst.fltr_Inst_Id;

        if (object.hasOwnProperty('mJnr_Inst'))
            return object.mJnr_Inst.mJnr_Inst_Id;

        if (object.hasOwnProperty('splt_Inst'))
            return object.splt_Inst.splt_Inst_Id;

        if (object.hasOwnProperty('rlup_Inst'))
            return object.rlup_Inst.rlup_Inst_Id;

        if (object.hasOwnProperty('tStg_Inst'))
            return object.tStg_Inst.tStg_Inst_Id;

        if (object.hasOwnProperty('venn_Unon_Inst'))
            return object.venn_Unon_Inst.venn_Unon_Inst_Id;

        if (object.hasOwnProperty('input_Inst'))
            return object.input_Inst.input_Inst_Id;

        if (object.hasOwnProperty('lkup_Inst'))
            return object.lkup_Inst.lkup_Inst_Id;

        if (object.hasOwnProperty('transform_Inst'))
            return object.transform_Inst.transform_Inst_Id;

        if (object.hasOwnProperty('output_Inst'))
            return object.output_Inst.output_Inst_Id;

        if (object.hasOwnProperty('rDesign_Inst'))
            return object.rDesign_Inst.rDesign_Inst_Id;

        if (object.hasOwnProperty('tCmd_Inst'))
            return object.tCmd_Inst.tCmd_Inst_Id;

        if (object.hasOwnProperty('dxMp_Inst'))
            return object.dxMp_Inst.dxMp_Inst_Id;

        if (object.hasOwnProperty('dCmd_Inst'))
            return object.dCmd_Inst.dCmd_Inst_Id;

        if (object.hasOwnProperty('hdfsCmd_Inst'))
            return object.hdfsCmd_Inst.hdfsCmd_Inst_Id;

        if (object.hasOwnProperty('kafkaConsumer_Inst'))
            return object.kafkaConsumer_Inst.kafkaconsumer_inst_id;

        if (object.hasOwnProperty('gpsSubscriber_Inst'))
            return object.gpsSubscriber_Inst.gpsSubscriber_inst_id;

        if (object.hasOwnProperty('looper'))
            return object.looper.looper_Id;

        if (object.hasOwnProperty('looper_End'))
            return object.looper_End.looper_End_Id;

        if (object.hasOwnProperty('tEmail_Inst'))
            return object.tEmail_Inst.tEmail_Inst_Id;

        if (object.hasOwnProperty('fileTransfer_Inst'))
            return object.fileTransfer_Inst.fileTransfer_Inst_Id;

        if (object.hasOwnProperty('restJob_Inst'))
            return object.restJob_Inst.restJob_Inst_Id;

        if (object.hasOwnProperty('office365_Inst'))
            return object.office365_Inst.office365_Inst_Id;

        if (object.hasOwnProperty('jsonC_Inst')) //add by sharmi on 4-3-25
            return object.jsonC_Inst.jsonc_Inst_Id;

        if (object.hasOwnProperty('cobolConverter_Inst'))
            return object.cobolConverter_Inst.cobolConverter_Inst_Id;

        if (object.hasOwnProperty('gps_Inst'))
            return object.gps_Inst.gps_Inst_Id;
        return -1;

    }

    getInstObject(object) {

        if (object.hasOwnProperty('src_Inst'))
            return [object.src_Inst, 'instNm'];

        if (object.hasOwnProperty('expr_Inst'))
            return [object.expr_Inst, 'nm'];

        if (object.hasOwnProperty('tgt_Inst'))
            return [object.tgt_Inst, 'instNm'];

        if (object.hasOwnProperty('fltr_Inst'))
            return [object.fltr_Inst, 'nm'];

        if (object.hasOwnProperty('mJnr_Inst'))
            return [object.mJnr_Inst, 'nm'];

        if (object.hasOwnProperty('splt_Inst'))
            return [object.splt_Inst, 'nm'];

        if (object.hasOwnProperty('rlup_Inst'))
            return [object.rlup_Inst, 'nm'];

        if (object.hasOwnProperty('tStg_Inst'))
            return [object.tStg_Inst, 'nm'];

        if (object.hasOwnProperty('venn_Unon_Inst'))
            return [object.venn_Unon_Inst, 'nm'];

        if (object.hasOwnProperty('input_Inst'))
            return [object.input_Inst, 'nm'];

        if (object.hasOwnProperty('transform_Inst'))
            return [object.transform_Inst, 'nm'];

        if (object.hasOwnProperty('output_Inst'))
            return [object.output_Inst, 'nm'];

        if (object.hasOwnProperty('rDesign_Inst'))
            return [object.rDesign_Inst, 'nm'];

        if (object.hasOwnProperty('tCmd_Inst'))
            return [object.tCmd_Inst, 'nm'];

        if (object.hasOwnProperty('dxMp_Inst'))
            return [object.dxMp_Inst, 'instNm'];

        if (object.hasOwnProperty('dCmd_Inst'))
            return [object.dCmd_Inst, 'nm'];

        if (object.hasOwnProperty('hdfsCmd_Inst'))
            return [object.hdfsCmd_Inst, 'nm'];

        if (object.hasOwnProperty('kafkaConsumer_Inst'))
            return [object.kafkaConsumer_Inst, 'nm'];

         if (object.hasOwnProperty('gpsSubscriber_Inst'))
            return [object.gpsSubscriber_Inst, 'nm'];

        if (object.hasOwnProperty('looper'))
            return [object.looper, 'nm'];

        if (object.hasOwnProperty('looper_End'))
            return [object.looper_End, 'nm'];

        if (object.hasOwnProperty('tEmail_Inst'))
            return [object.tEmail_Inst, 'nm'];

        if (object.hasOwnProperty('fileTransfer_Inst'))
            return [object.fileTransfer_Inst, 'nm'];

        if (object.hasOwnProperty('restJob_Inst'))
            return [object.restJob_Inst, 'nm'];

        if (object.hasOwnProperty('office365_Inst'))
            return [object.office365_Inst, 'nm'];

        if (object.hasOwnProperty('jsonC_Inst'))  //add by sharmi on 4-3-25
            return [object.jsonC_Inst, 'nm'];

        if (object.hasOwnProperty('cobolConverter_Inst'))
            return [object.cobolConverter_Inst, 'nm'];

        if (object.hasOwnProperty('gps_Inst'))
            return [object.gps_Inst, 'nm'];

        return -1;

    }

    // getDistKeyFlagList(list1, list2, list3) {
    //     let distKeyFlagListLength = 0;

    //     if (list1)
    //         distKeyFlagListLength += list1.length;

    //     if (list2)
    //         distKeyFlagListLength += list2.length;

    //     if (list3)
    //         distKeyFlagListLength += list3.length;


    //     if (distKeyFlagListLength > 4)
    //         distKeyFlagListLength = 4;

    //     let list = [];
    //     for (let i = 0; i <= distKeyFlagListLength; i++) {
    //         list.push({ "value": i });
    //     }

    //     return list;
    // }

    // distKeyFlagChanged(attribute, list1, list2, list3) {


    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }
    //     }


    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }

    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }
    //     }
    // }

    // clusterFlagChanged(attribute, list1, list2, list3) {


    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.clusterFlag == attributeExist.clusterFlag) {
    //                 attributeExist.clusterFlag = 0;
    //                 break;
    //             }
    //         }
    //     }


    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.clusterFlag == attributeExist.clusterFlag) {
    //                 attributeExist.clusterFlag = 0;
    //                 break;
    //             }
    //         }

    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.clusterFlag == attributeExist.clusterFlag) {
    //                 attributeExist.clusterFlag = 0;
    //                 break;
    //             }
    //         }
    //     }
    // }

    // orderByFlag(attribute, list1, list2, list3) {


    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
    //                 attributeExist.orderBy = 0;
    //                 break;
    //             }
    //         }
    //     }


    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
    //                 attributeExist.orderBy = 0;
    //                 break;
    //             }
    //         }

    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
    //                 attributeExist.orderBy = 0;
    //                 break;
    //             }
    //         }
    //     }
    // }
    // sortByChanged(attribute, list1, list2, list3) {


    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.sortBy == attributeExist.sortBy) {
    //                 attributeExist.sortBy = 0;
    //                 break;
    //             }
    //         }
    //     }


    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.sortBy == attributeExist.sortBy) {
    //                 attributeExist.sortBy = 0;
    //                 break;
    //             }
    //         }

    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.sortBy == attributeExist.sortBy) {
    //                 attributeExist.sortBy = 0;
    //                 break;
    //             }
    //         }
    //     }
    // }

    partitionflagChanged(attribute: any, list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null) {
        console.log('factory:: DIAttributes:: partitionflagChanged()::');

        if (list1) {
            for (let i = 0; i < list1.length; i++) {
                let attributeExist = list1[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.partitionflag == attributeExist.partitionflag) {
                    attributeExist.partitionflag = 0;
                    break;
                }
            }
        }


        if (list2) {
            for (let i = 0; i < list2.length; i++) {
                let attributeExist = list2[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.partitionflag == attributeExist.partitionflag) {
                    attributeExist.partitionflag = 0;
                    break;
                }
            }

        }

        if (list3) {
            for (let i = 0; i < list3.length; i++) {
                let attributeExist = list3[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.partitionflag == attributeExist.partitionflag) {
                    attributeExist.partitionflag = 0;
                    break;
                }
            }
        }
    }

    getAttributesLengthList(list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null): Array<any> {
        let attributesLength = 0;

        if (list1)
            attributesLength += list1.length;

        if (list2)
            attributesLength += list2.length;

        if (list3)
            attributesLength += list3.length;

        let list: Array<any> = new Array<any>();
        for (let i: number = 0; i <= attributesLength; i++) {
            list.push({ "value": i });
        }

        return list;
    }

    verifyBigQueryPartitionDataType(attrDTyp_Id: number): boolean {
        if (attrDTyp_Id == 91 || attrDTyp_Id == 93 || attrDTyp_Id == 4) {
            return true;
        }
        return false;
    }
    getRedefinesList(objectWrapper: ObjectWrapper, attributes: Array<Attribute>, attribute: Attribute) {


        if (attribute.srt_Order == 0) return;

        let list = [];
        //			for( let i = 0; i < attributes.length; i++ ) {

        for (let i = attribute.srt_Order - 1; i >= 0; i--) {
            if (attribute.attrNm != attributes[i].attrNm &&
                attribute.attr_Id != attributes[i].parent_Attr_Id)
                list.push({ "name": attributes[i].attrNm, 'attr_Id': attributes[i].attr_Id });
        }

        list.push({ "name": 'Please Select', 'attr_Id': -1 });

        return list;
    }

    getYesNo(): Array<LabelValueObj> {
        let labelValueObjs = new Array<LabelValueObj>();

        let yesObj = new LabelValueObj();
        yesObj.label = 'Yes';
        yesObj.value = 'Yes';
        labelValueObjs.push(yesObj);

        let noObj = new LabelValueObj();
        noObj.label = 'No';
        noObj.value = 'No';
        labelValueObjs.push(noObj);

        return labelValueObjs
    }

    getOptionsByValues(values: Array<string>): Array<LabelValueObj> {

        if (!values) return [];

        let labelValueObjs = new Array<LabelValueObj>();

        for (let i: number = 0; i < values.length; i++) {
            let labelValueObj = new LabelValueObj();
            labelValueObj.label = values[i];
            labelValueObj.value = values[i];
            labelValueObjs.push(labelValueObj);
        }

        return labelValueObjs;
    }



    getRelatedDbtypes(dbTyp_Id) {
        switch (dbTyp_Id) {
            case 3: return [3, 9, 15, 17, 32];

            case 6: return [6, 14, 16, 32, 33];

            case 31: return [3, 15, 17];

            case 18: return [14, 18];

            case 8: return [8, 14];

            case 37: return [3, 9, 15, 17, 32];

            case 47: return [3, 9, 15, 17, 32];

            default: return [dbTyp_Id];

        }

    }

    nonDatabasesDTypIds(dbTyp_Id) {

        return [14, 16, 32, 33].indexOf(dbTyp_Id);
    }

    isTransExist(objectWrapper) {

        for (let i = 0; i < objectWrapper.transformWrappers.length; i++) {
            let transformWrapper = objectWrapper.transformWrappers[i];

            if (this.isSourceOrTargetExist(transformWrapper)) return true;

            if (transformWrapper.obj_Cd == "DOBJIS" || transformWrapper.obj_Cd == "DOBJIT") continue;

            return true;
        }

        return false;
    }

    isSourceOrTargetExist(transformWrapper) {

        if (transformWrapper.dbTyp_Id == 15 ||
            transformWrapper.dbTyp_Id == 17 ||
            transformWrapper.dbTyp_Id == 22 ||
            transformWrapper.dbTyp_Id == 23 ||
            transformWrapper.dbTyp_Id == 31 ||
            transformWrapper.dbTyp_Id == 34 ||
            transformWrapper.dbTyp_Id == 37 ||
            transformWrapper.dbTyp_Id == 40) return true;
        if (transformWrapper.obj_Cd == "DOBJIS") {
            if (transformWrapper.dbTyp_Id == 35) return true;
        }

        if (transformWrapper.obj_Cd == "DOBJIT" &&
            transformWrapper.object.dataObject.dObj.localFlag == "Y") return true;

        return false;
    }

    clearSubObjects(objectWrapper) {
        objectWrapper.sub_Ids = new Map<number, any>();
        this.util.splice(objectWrapper.subNames);
    }

    clearOupPutAttributes(objectWrapper) {
        objectWrapper.outPutAttributesNamesList = [];
        objectWrapper.outPutAttributesHMapIds = [];
        objectWrapper.outPutAttributeObjectsHMapIds = [];
        objectWrapper.outPutAttributes.splice(0, objectWrapper.outPutAttributes.length);
    }

    // getAttributeNames(objectWrapper) {
    //     let attributeNames = [];
    //     for (let i = 0; i < objectWrapper.object.attributes.length; i++) {
    //         attributeNames = this.packSubNames('attrNm', objectWrapper.object.attributes, objectWrapper);
    //         return attributeNames;
    //     }
    // }

    /////////////

    // getAttributesLengthList(list1, list2, list3) {
    //     let attributesLength = 0;

    //     if (list1)
    //         attributesLengthy += list1.length;

    //     if (list2)
    //         attributesLength += list2.length;

    //     if (list3)
    //         attributesLength += list3.length;

    //     let list = [];
    //     for (let i = 0; i <= attributesLength; i++) {
    //         list.push({ "value": i });
    //     }

    //     return list;
    // }

    // getDistKeyFlagList(list1, list2, list3) {
    //     let distKeyFlagListLength = 0;

    //     if (list1)
    //         distKeyFlagListLength += list1.length;

    //     if (list2)
    //         distKeyFlagListLength += list2.length;

    //     if (list3)
    //         distKeyFlagListLength += list3.length;


    //     if (distKeyFlagListLength > 4)
    //         distKeyFlagListLength = 4;

    //     let list = [];
    //     for (let i = 0; i <= distKeyFlagListLength; i++) {
    //         list.push({ "value": i });
    //     }

    //     return list;
    // }

    // distKeyFlagChanged(attribute, list1, list2, list3) {
    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }
    //     }

    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }

    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.distKeyFlag == attributeExist.distKeyFlag) {
    //                 attributeExist.distKeyFlag = 0;
    //                 break;
    //             }
    //         }
    //     }

    // }

    clusterFlagChanged(attribute: any, list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null) {
        if (list1) {
            for (let i = 0; i < list1.length; i++) {
                let attributeExist = list1[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.clusterFlag == attributeExist.clusterFlag) {
                    attributeExist.clusterFlag = 0;
                    break;
                }
            }
        }

        if (list2) {
            for (let i = 0; i < list2.length; i++) {
                let attributeExist = list2[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.clusterFlag == attributeExist.clusterFlag) {
                    attributeExist.clusterFlag = 0;
                    break;
                }
            }
        }

        if (list3) {
            for (let i = 0; i < list3.length; i++) {
                let attributeExist = list3[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.clusterFlag == attributeExist.clusterFlag) {
                    attributeExist.clusterFlag = 0;
                    break;
                }
            }
        }
    }

    orderByFlag(attribute: any, list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null) {
        if (list1) {
            for (let i = 0; i < list1.length; i++) {
                let attributeExist = list1[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id;
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id;

                if (_attr_Id == _existAttr_Id) continue;
                if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
                    attributeExist.orderBy = 0;
                    break;
                }
            }
        }

        if (list2) {
            for (let i = 0; i < list2.length; i++) {
                let attributeExist = list2[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
                    attributeExist.orderBy = 0;
                    break;
                }
            }
        }

        if (list3) {
            for (let i = 0; i < list3.length; i++) {
                let attributeExist = list3[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (parseInt(attribute.orderBy) == attributeExist.orderBy) {
                    attributeExist.orderBy = 0;
                    break;
                }
            }
        }
    }

    sortByChanged(attribute, list1, list2, list3) {
        if (list1) {
            for (let i = 0; i < list1.length; i++) {
                let attributeExist = list1[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id;
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id;
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.sortBy == attributeExist.sortBy) {
                    attributeExist.sortBy = 0;
                    break;
                }
            }
        }

        if (list2) {
            for (let i = 0; i < list2.length; i++) {
                let attributeExist = list2[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.sortBy == attributeExist.sortBy) {
                    attributeExist.sortBy = 0;
                    break;
                }
            }
        }

        if (list3) {
            for (let i = 0; i < list3.length; i++) {
                let attributeExist = list3[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (attribute.sortBy == attributeExist.sortBy) {
                    attributeExist.sortBy = 0;
                    break;
                }
            }
        }
    }

    // partitionflagChanged(attribute, list1, list2, list3) {
    //     if (list1) {
    //         for (let i = 0; i < list1.length; i++) {
    //             let attributeExist = list1[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.partitionflag == attributeExist.partitionflag) {
    //                 attributeExist.partitionflag = 0;
    //                 break;
    //             }
    //         }
    //     }

    //     if (list2) {
    //         for (let i = 0; i < list2.length; i++) {
    //             let attributeExist = list2[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.partitionflag == attributeExist.partitionflag) {
    //                 attributeExist.partitionflag = 0;
    //                 break;
    //             }
    //         }
    //     }

    //     if (list3) {
    //         for (let i = 0; i < list3.length; i++) {
    //             let attributeExist = list3[i];
    //             let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
    //             let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
    //             if (_attr_Id == _existAttr_Id) continue;

    //             if (attribute.partitionflag == attributeExist.partitionflag) {
    //                 attributeExist.partitionflag = 0;
    //                 break;
    //             }
    //         }
    //     }
    // }

    // setShortName(name) {
    //     return name.length > 15 ? name.slice(0, 15) + '...' : name;
    // }

    this(timestamp) {
        if (timestamp == -1
            || timestamp == undefined) {
            timestamp = new Date();
        }
        timestamp = new Date("dd-MMM-yyyy HH:mm")
        return timestamp;
    }

    isReadMode(mode_Ind: string): boolean {
        return mode_Ind != CommonEnums.mode_Ind.WRITE;
    }

    /**
     * @forSplitterShortName
     * @param name
     */



    // getAttributesLengthList(list1, list2, list3) {
    //     let attributesLength = 0;

    //     if (list1)
    //         attributesLength += list1.length;

    //     if (list2)
    //         attributesLength += list2.length;

    //     if (list3)
    //         attributesLength += list3.length;

    //     let list = [];
    //     for (let i = 0; i <= attributesLength; i++) {
    //         list.push({ "value": i });
    //     }

    //     return list;
    // }

    getDistKeyFlagList(list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null) {
        let distKeyFlagListLength = 0;

        if (list1)
            distKeyFlagListLength += list1.length;

        if (list2)
            distKeyFlagListLength += list2.length;

        if (list3)
            distKeyFlagListLength += list3.length;

        if (distKeyFlagListLength > 4)
            distKeyFlagListLength = 4;

        let list = [];
        for (let i = 0; i <= distKeyFlagListLength; i++) {
            list.push({ "value": i });
        }

        return list;
    }

    distKeyFlagChanged(attribute: any, list1: Array<any>, list2: Array<any> = null, list3: Array<any> = null) {
        if (list1) {
            for (let i = 0; i < list1.length; i++) {
                let attributeExist = list1[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (parseInt(attribute.distKeyFlag) == attributeExist.distKeyFlag) {
                    attributeExist.distKeyFlag = 0;
                    break;
                }
            }
        }

        if (list2) {
            for (let i = 0; i < list2.length; i++) {
                let attributeExist = list2[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (parseInt(attribute.distKeyFlag) == attributeExist.distKeyFlag) {
                    attributeExist.distKeyFlag = 0;
                    break;
                }
            }

        }

        if (list3) {
            for (let i = 0; i < list3.length; i++) {
                let attributeExist = list3[i];
                let _attr_Id = attribute.hasOwnProperty('lAttr_Id') ? attribute.lAttr_Id : attribute.attr_Id
                let _existAttr_Id = attributeExist.hasOwnProperty('lAttr_Id') ? attributeExist.lAttr_Id : attributeExist.attr_Id
                if (_attr_Id == _existAttr_Id) continue;

                if (parseInt(attribute.distKeyFlag) == attributeExist.distKeyFlag) {
                    attributeExist.distKeyFlag = 0;
                    break;
                }
            }
        }

    }

    isSchCode(obj_Cd: string): boolean {
        let schedulerObj_Cds = ['CMDTASK', 'SCH_FILEWATCHER', 'CALNDR', 'EMAILACTION', 'FILEEVENT', 'CMDEVENT']
        return schedulerObj_Cds.indexOf(obj_Cd) != -1;
    }

    /**
     * @forSplitterShortName
     * @param name
     */
    setShortNameForSplitterOutList(name: string) {
        return name.length > 8 ? name.slice(0, 8) + '...' : name;
    }

    hasPP(name) {
        if (name.startsWith('$', 0)) {
            let nameTmp = name.substring(1, name.length);
            return !(/^\w+$/.test(nameTmp));
        }
        else {
            return !(/^\w+$/.test(name));
        }

    }

    hasPPWithAtSign(name) {
       const isProjectParam = name.startsWith('$') || name.startsWith('@');

        if (!isProjectParam) {
            return false;
        }

        if (name.startsWith('$', 0)) {
            let nameTmp = name.substring(1, name.length);
            return !(/^[\w.@]+$/.test(nameTmp));
        }
        else {
            return !(/^[\w.@]+$/.test(name));
        }
    }
}
